import React from 'react';
import { KibAddFillIcon } from '@chewy/kib-icons-react';
import { usePetForm } from '../PetFormContext/PetFormContext';
import { scrollBody } from '../../../util/scrollBody';
import { addClinicText } from './vetContent';
import OnboardingVetClinic from './OnboardingVetClinic';
import AddVetSheet from './AddVetSheet';
import { Clinics } from './vetClinicResponse';

const AddVetClinic = ({
  clinics,
  setClinics,
}: {
  clinics: Clinics;
  setClinics: React.Dispatch<React.SetStateAction<Clinics>>;
}) => {
  const { setShowAddVetSheet, showAddVetSheet, showOnboardingVetSheet } = usePetForm();
  return (
    <>
      <button
        className="pet-form-vet-add__button"
        type="button"
        onClick={() => {
          setShowAddVetSheet(true);
          scrollBody(false);
        }}
        data-testid="pet-form-vet-add-clinic"
      >
        <span className="pet-form-vet-add__button--icon">
          <KibAddFillIcon />
        </span>
        {addClinicText}
      </button>
      {showAddVetSheet && <AddVetSheet clinics={clinics} setClinics={setClinics} />}
      {showOnboardingVetSheet && <OnboardingVetClinic clinics={clinics} setClinics={setClinics} />}
    </>
  );
};

export default AddVetClinic;
